import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface IProps {
    icon: string;
    text: string;
    urlText: string;
}

const SidebarItem = ({ icon, text, urlText }: IProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isActive = location.pathname === urlText;

    const navigateToUrl = () => {
        navigate(urlText);
    };

    return (
        <div
            className={`tw-full tw-flex tw-items-center tw-justify-start tw-gap-x-[10px] tw-p-2 tw-rounded-md tw-cursor-pointer ${isActive ? 'tw-bg-gray-300' : ''}`}
            onClick={navigateToUrl}
        >
            <i className={`ph-bold ph-${icon} lg ${isActive ? 'tw-text-purple-300' : ''}`}></i>
            <span className={`tw-text-base tw-font-medium ${isActive ? 'tw-text-purple-300' : ''}`}>
                {text}
            </span>
        </div>
    );
};

export default SidebarItem;
